module.exports = __webpack_public_path__ + "img/fingerprint.08aedf39.svg";